import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FileService } from 'src/app/Services/file.service';

@Component({
  selector: 'app-policy-pdfviwer',
  templateUrl: './policy-pdfviwer.component.html',
  styleUrls: ['./policy-pdfviwer.component.css']
})
export class PolicyPDFViwerComponent implements OnInit {
  fileName: string;
  dataLocalUrl;

  constructor(private filePDFStreamService: FileService
              , private pdfRouter: ActivatedRoute
              , private sanitizer: DomSanitizer ) { }

  ngOnInit(): void {
    //this.getPDFFileStream_SchoolboardPolicy();
    this.getCharterSchool_Doc();
  }

  private getPDFFileStream_SchoolboardPolicy(): void {
    this.fileName = this.pdfRouter.snapshot.paramMap.get('filename');
    this.filePDFStreamService.getPDFFileStream("/PolicyDocGetStream/policy_5204.pdf", this.fileName).subscribe((data: Blob) => {
      console.log("data: " + JSON.stringify(data));
      this.dataLocalUrl = data;
      //this.dataLocalUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
      console.log("dataLocalUrl: " + this.dataLocalUrl);
    });
  }

  private getCharterSchool_Doc(): void {
    this.filePDFStreamService.getPDFFileStream_CharterSchool("/sharepoint?filename=5233_2023_07_01", "").subscribe(
      data => {
        this.dataLocalUrl = data;
      }
    );
  }

}
